export const inputCharacterLimit = {
    EVENT_NAME_CHARACTER_LIMIT: 50,
    SUBSCRIPTION_NAME_CHARACTER_LIMIT: 50,
    TEMPLATE_NAME_CHARACTER_LIMIT: 64,
    LOCATION_NAME_CHARACTER_LIMIT: 32,
    TICKET_NAME_CHARACTER_LIMIT: 36,
}